export default "__VITE_ASSET__69dbdd9e__"